<template>
      <!-- FAQ -->
    <section id="faq" class="ssl-section">
      <div class="inner-bound pt50 pb60">
        <h2 class="text-section-title" v-animate="'fadeInUp'">
          {{ faqTitle }}
        </h2>
        <div class="ssl-faq-list">
          <div
            v-for="(item, index) in faqItems"
            :key="index"
            class="ssl-faq-item"
            v-animate="'fadeInUp'"
          >
            <div class="faq-row">
              <h4 class="faq-index">
                {{ String(index + 1).padStart(2, "0") }}/
              </h4>
              <div class="faq-content">
                <h3 class="faq-question">{{ item.q }}</h3>
                <!-- <p class="faq-answer">{{ item.a }}</p> -->
                 <p v-html="item.a"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>


<script setup>
const { t, tm, rt, locale } = useI18n();

const props = defineProps({
  faqTitle: { type: String, default: "" },
  faqItems: { type: Array, default: () => [] }
})
</script>
 
